// noinspection GraphQLUnresolvedReference

import { gql } from 'graphql-request'

/**
 * Fragmento de tipo articulo
 */
export const tipoArticuloFragment = gql`
  fragment tipoArticuloFragment on TipoArticulo {
    _id
    codigo
    descripcion
    orden
    notas
    state
    usucre
    createdAt
    usumod
    updatedAt
  }
`
